<template>
 <div class="msv">
    <label class="form__input">
      <span class="form__label">Locale #1</span>
      <div class="form__field-wrapper">
        <input type="text"
               class="form__field"
               placeholder="Locale #1"
               v-model="$parent.clientDataModel.msv.msv_locale_1">
      </div>
    </label>
    <label class="form__input">
      <span class="form__label">Locale #2</span>
      <div class="form__field-wrapper">
        <input type="text"
               class="form__field"
               placeholder="Locale #2"
               v-model="$parent.clientDataModel.msv.msv_locale_2">
      </div>
    </label>
    <label class="form__input">
      <span class="form__label">Locale #3</span>
      <div class="form__field-wrapper">
        <input type="text"
               class="form__field"
               placeholder="Locale #3"
               v-model="$parent.clientDataModel.msv.msv_locale_3">
      </div>
    </label>
    <label class="form__input">
      <span class="form__label">Locale #4</span>
      <div class="form__field-wrapper">
        <input type="text"
               class="form__field"
               placeholder="Locale #4"
               v-model="$parent.clientDataModel.msv.msv_locale_4">
      </div>
    </label>
 </div>
</template>

<script>
export default {
  name: 'MSV'
}
</script>

<style lang="scss" scoped>
  .msv {
  }
</style>
